import * as React from 'react';
import { ListingState, BaseRouteProps } from '../../../interfaces';
import { ScoreCardGroupCharacteristic } from '../../../models';
import { ScoreCardGroupCharacteristicDataService } from '../../../services';
import { NavLink } from 'react-router-dom';
import { DataGrid } from '../../../components';

export class ScoreCardGroupCharacteristicListing extends React.Component<BaseRouteProps<{groupId: number}>, ListingState<ScoreCardGroupCharacteristic>> {
    private scoreCardGroupCharacteristicDataService = new ScoreCardGroupCharacteristicDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{groupId: number}>) {
        super(props);

        this.state = {
            entities: new Array<ScoreCardGroupCharacteristic>(),
        };
    }

    public componentDidMount() {
        const id = this.props.match.params.groupId;
        this.scoreCardGroupCharacteristicDataService.getAllByGroup(id).then((scoreCardGroupCharacteristics: ScoreCardGroupCharacteristic[]) => {
            this.setState(
                { entities: scoreCardGroupCharacteristics }
            );
        });
    }

    public render() {
        const listData = this.state.entities.map(entity => {
            return {
                'Name': entity.name,
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <span>
                    <NavLink className="btn btn-default" to={`/scorecard/${value}`}>View</NavLink>
                </span>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <div>
                <div className="content-header">
                    <div className="content-container">
                        <div className="row">
                            <div className="col-xs-7">
                                <div className="title">
                                    Score Card Group Characteristics
                                </div>
                            </div>
                            <div className="col-xs-5 text-right">
                                <NavLink className="btn btn-primary" to={`/scorecardgroup/${this.props.match.params.groupId}/create`}>
                                    <span className="glyphicon glyphicon-plus" /> Create
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <DataGrid entities={listData} columns={columnDefs} />
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreCard/scoreCardGroupCharacteristic/ScoreCardGroupCharacteristicListing.tsx